import { Box } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";
import { FONT_TEXT, FONT_UI } from "@/src/components/common/broadsheet/tokens";

const PlateCaption = ({
  label,
  text,
  placement = "above",
}: {
  label?: string | null;
  text?: string | null;
  placement?: "above" | "below";
}) => {
  if (!label && !text) return null;

  return (
    <Box
      sx={{
        pb: placement === "above" ? 0.375 : 0,
        pt: placement === "below" ? 0.375 : 0,
      }}
    >
      {label ? (
        <Box
          component="span"
          sx={{
            fontFamily: FONT_UI,
            fontSize: "0.6875rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "custom.ink",
            mr: 0.375,
          }}
        >
          {label}
        </Box>
      ) : null}
      {text ? (
        <Box
          sx={{
            display: "inline",
            fontFamily: FONT_TEXT,
            fontSize: "0.8125rem",
            lineHeight: 1.45,
            color: "custom.inkMuted",
            "& p": { display: "inline", m: 0 },
          }}
        >
          {ReactHtmlParser(text)}
        </Box>
      ) : null}
    </Box>
  );
};

export default PlateCaption;
